export default () => {
    return {
        mounted(delay = this.$store.animationDelay, scrollTrigger = true) {
            let stSettings = false;

            if (scrollTrigger) {
                stSettings = {
                    start: 'top 85%',
                    trigger: this.$refs.container
                };
            }

            const reveal = gsap.timeline({ scrollTrigger: stSettings });

            reveal
                .from(this.$refs.bgWrapper, { opacity: 0, duration: 0.2, delay: delay })
                .to(this.$refs.cover, { duration: 0.6, yPercent: 104, ease: 'expo.inOut' }, '<0.1')
                .fromTo(
                    this.$refs.bgWrapper,
                    { yPercent: -4, scale: 1.35 },
                    { duration: 0.9, yPercent: 0, scale: 1, ease: 'expo.inOut' },
                    '<-0.1'
                );
        }
    };
};
